// Sorani Kurdish dictionary (Kurdish script, Hewlêr/Silêmanî register). No
// Kurmanji, no Persian/Arabic calques where a normal Sorani word exists.
// Common tech loanwords (AI, app, web, MVP, CTO) kept as Kurdish tech writers
// actually write them.
import type { Dictionary } from './en';

export const ckb: Dictionary = {
  common: {
    skipToMainContent: 'چوونە ناوەڕۆکی سەرەکی',
  },
  meta: {
    homeTitle: 'Datacode | تێکەڵکردنی زیرەکی دەستکرد، چارەسەری LLM و کۆمپانیای گەشەپێدانی وێب',
    homeDescription:
      'Datacode ئاژانسێکی دیجیتاڵییە لە هەولێر، کوردستان. ئێمە ئەپی وێب، تێکەڵکردنی زیرەکی دەستکرد و بەرهەمی مۆبایل دیزاین و دروست دەکەین، لە یەکەم دێڕی کۆدەوە تا گەیشتن بە بەرهەم.',
  },
  header: {
    nav: {
      home: 'سەرەکی',
      portfolio: 'کارەکانمان',
      products: 'بەرهەمەکان',
      about: 'دەربارەمان',
      contact: 'پەیوەندی',
      careers: 'هەلی کار',
    },
    toggleMenuAriaLabel: 'کردنەوە/داخستنی مینیو',
    email: 'info@datacode.app',
    socials: {
      instagramAriaLabel: 'Instagram',
      linkedinAriaLabel: 'LinkedIn',
      twitterAriaLabel: 'Twitter/X',
    },
    tagline: 'Datacode',
    languageSwitcher: {
      ariaLabel: 'زمان هەڵبژێرە',
      en: 'EN',
      ar: 'عربي',
      ckb: 'کوردی',
    },
  },
  footer: {
    eyebrow: 'پرۆژەیەک دەست پێ بکە',
    // Two-line pitch. Keep as two entries since it renders as two lines
    // ("Have something to build?" then a dimmer sub-line).
    pitchLine1: 'شتێکت هەیە دەتەوێت دروستی بکەیت؟',
    pitchLine2: 'قسە بکە لەگەڵ ئەو کەسانەی کە دروستی دەکەن.',
    email: 'info@datacode.app',
    phone: '+964-751-449-1008',
    address: {
      line1: 'شەقامی گوندی ئینگلیزی',
      line2: 'هەولێر، هەرێمی کوردستان، عێراق',
    },
    columns: {
      studio: 'ستۆدیۆ',
      services: 'خزمەتگوزارییەکان',
      products: 'بەرهەمەکان',
      contact: 'پەیوەندی',
    },
    studioLinks: {
      home: 'سەرەکی',
      portfolio: 'کارەکانمان',
      about: 'دەربارەمان',
      articles: 'بابەتەکان',
      careers: 'هەلی کار',
    },
    serviceLinks: {
      webDesign: 'دیزاین و گەشەپێدانی وێبسایت',
      mobileApp: 'گەشەپێدانی ئەپی مۆبایل',
      aiIntegration: 'تێکەڵکردنی زیرەکی دەستکرد',
      uiUx: 'دیزاینی UI/UX',
      allServices: 'هەموو خزمەتگوزارییەکان',
    },
    productLinks: {
      dilaCrm: 'DilaCRM',
      dilaErp: 'DilaERP',
      dilaMenu: 'dila.menu',
      allProducts: 'هەموو بەرهەمەکان',
    },
    legalLinks: {
      support: 'پشتگیری',
      terms: 'مەرجەکان',
      privacy: 'تایبەتمەندی',
    },
    copyright: 'Datacode',
    erbilLabel: 'هەولێر',
    backToTop: 'سەرەوە',
  },
  hero: {
    // Rendered letter-by-letter, kept as a single word so the split('')
    // animation still works.
    title: 'DATACODE',
    subtitleMobile:
      'ئێمە ئەپی وێب، ئامرازی زیرەکی دەستکرد و بەرهەمی مۆبایل دیزاین و دروست دەکەین، لە یەکەم دێڕی کۆدەوە تا گەیشتن بە بەرهەم. لە کوردستانەوە دروست دەکرێت و بۆ هەموو جیهان دەنێردرێت.',
    subtitleDesktopLine1: 'ئێمە ئەپی وێب، ئامرازی زیرەکی دەستکرد و بەرهەمی',
    subtitleDesktopLine2: 'مۆبایل دیزاین و دروست دەکەین، لە یەکەم دێڕی کۆدەوە تا بەرهەم.',
    subtitleDesktopLine3: 'لە کوردستانەوە دروست دەکرێت، بۆ هەموو جیهان دەنێردرێت.',
    subtitleRevealLine1: 'بێ قاڵبی ئامادە. بێ ناوبژیوان. بێ ڕادەستکردنی کار بۆ تیمێکی تازەکار.',
    subtitleRevealLine2: 'ڕاستەوخۆ لەگەڵ ئەو کەسانە کار دەکەیت کە کۆدەکە دەنووسن.',
    subtitleRevealLine3: 'کورتەی قسەکە ئەوەیە.',
    scrollToExplore: 'بۆ گەڕان بڕۆ خوارەوە',
    statusLine: {
      location: 'هەولێر، بارەگای سەرەکی',
      systemsLive: 'سیستەمەکان کاردەکەن',
    },
  },
  portfolio: {
    // Visually hidden heading above the featured-work gallery.
    sectionHeading: 'کارە هەڵبژاردەکان',
    loading: 'پرۆژەکان بار دەکرێن...',
    empty: 'هێشتا هیچ پرۆژەیەک نییە.',
    getInTouch: 'پەیوەندیمان پێوە بکە',
    imageUnavailable: 'وێنە بەردەست نییە',
    viewLabel: 'بینین',
  },
  statement: {
    row1: {
      webApps: 'ئەپی وێب',
      aiTools: 'ئامرازی زیرەکی دەستکرد',
      mobile: 'مۆبایل',
      platforms: 'پلاتفۆرم',
      production: 'بەرهەم',
    },
    row2: {
      design: 'دیزاین',
      build: 'دروستکردن',
      ship: 'بڵاوکردنەوە',
      scale: 'فراوانکردن',
      support: 'پشتگیری',
    },
    mockupAlt: 'ڕووکاری چەندین ئەپ',
  },
  glassStack: {
    // Visually hidden heading; the eyebrow below it is the visible label.
    sectionHeading: 'چۆن دروستی دەکەین',
    eyebrow: 'چۆن دروستی دەکەین',
    layers: {
      infrastructure: {
        title: 'ژێرخان و ئاسایش',
        desc: 'بڵاوکردنەوە، چاودێری و ئاسایش لە یەکەم ڕۆژەوە جێبەجێ دەکرێن، ئەو چینەیەی کە هەموو شتی تریان لەسەر وەستاوە.',
      },
      ai: {
        title: 'زیرەکی دەستکرد و کارگێڕەکان',
        desc: 'تایبەتمەندی زیرەکانە و ئۆتۆماتیک لەناو بەرهەمی ڕاستەقینەدا چەسپاون، یاریدەدەرانێک کە بەڕاستی بڵاو دەکرێنەوە، نەک تەنها نموونەیەکی نمایشی.',
      },
      web: {
        title: 'پلاتفۆرمی وێب',
        desc: 'ماڵپەڕ و پلاتفۆرمی خێرا کە باش لە گەڕانەکاندا دەردەکەون و بەرگەی هاتوچۆی ڕاستەقینە دەگرن.',
      },
      mobile: {
        title: 'ئەپی مۆبایل',
        desc: 'ئەپی پاڵاوتوو بۆ iPhone و Android، یەک تیم بۆ هەردوو فرۆشگا بڵاوی دەکاتەوە.',
      },
      design: {
        title: 'دیزاین و کارلێک',
        desc: 'ڕووکار لە ناوەوە دیزاین دەکرێن، جووڵە، براند و ئەزموونی بەکارهێنەر پێش نووسینی یەک دێڕ کۆد دیاری دەکرێن.',
      },
    },
  },
  skills: {
    // Visually hidden heading; the eyebrow below it is the visible label.
    sectionHeading: 'بوارەکانی کارمان',
    eyebrow: 'بوارەکانی کارمان',
    fallback: {
      webDesign: 'دیزاینی وێب',
      mobileAppDevelopment: 'گەشەپێدانی ئەپی مۆبایل',
      uiUxDesign: 'دیزاینی UI/UX',
      aiEngineering: 'ئەندازیاری زیرەکی دەستکرد',
      aiAgentsIntegrations: 'کارگێڕی زیرەکی دەستکرد و تێکەڵکردن',
      techDueDiligence: 'پێداچوونەوەی تەکنیکی',
      fractionalCto: 'CTOی کاتی و دروستکردنی تیم',
      mvpMobileWebsite: 'MVP بۆ مۆبایل/وێبسایت',
    },
  },
  contact: {
    eyebrow: 'پرۆژەیەک دەست پێ بکە',
    title: 'با قسە بکەین',
    subtitle:
      'پێمان بڵێ چیت دەوێت دروستی بکەیت. وەڵامت لە کەسانێک وەردەگریت کە بەڕاستی کار دەکەن لەسەری، نەک لە بەشی فرۆش.',
    email: 'info@datacode.app',
    phone: '+964-751-449-1008',
    labels: {
      email: 'ئیمەیل',
      location: 'شوێن',
      phone: 'تەلەفۆن',
    },
    location: {
      line1: 'هەولێر، هەرێمی کوردستان',
      line2: 'عێراق',
    },
    form: {
      nameLabel: 'ناو',
      emailLabel: 'ئیمەیل',
      messageLabel: 'پەیام',
      sending: 'دەنێردرێت...',
      send: 'ناردنی پەیام',
      success: 'سوپاس! پەیامەکەت نێردرا، بەم زووانە پەیوەندیت پێوە دەکەین.',
      error: 'هەڵەیەک ڕوویدا. ئیمەیلمان بۆ بنێرە: info@datacode.app',
      validation: {
        nameMin: 'ناو دەبێت لانیکەم دوو پیت بێت',
        emailInvalid: 'تکایە ئیمەیلێکی دروست بنووسە',
        messageMin: 'پەیام دەبێت لانیکەم 10 پیت بێت',
      },
    },
  },
  ourStudio: {
    eyebrow: 'دیزاین و کارلێک',
    // Rendered letter-by-letter, kept as a single phrase so the split('')
    // animation still works.
    title: 'ستۆدیۆمان',
  },
  careers: {
    index: {
      eyebrow: 'هەلی کار',
      heading: 'هەلی کاری بەردەست',
      subtitle: 'لە هەولێر، کوردستان کارمەند وەردەگرین، ئەو کەسانەی دەتوانن سەربەخۆ کار بکەن و بەرپرسیارێتی کارەکەیان هەڵبگرن، نەک تەنها شوێنێک پڕ بکەنەوە.',
      empty: 'ئێستا هیچ هەلێکی کار بەردەست نییە، دواتر سەردانمان بکە.',
      metaTitle: 'هەلی کار',
      metaDescription: 'هەلی کاری بەردەست لە داتاکۆد، شارەزای فرۆش و شارەزای پەیوەندی گشتی و فرۆش، وەرگرتنی کارمەند لە هەولێر، کوردستان.',
    },
    job: {
      openings: 'هەلی بەتاڵ',
      viewRole: 'بینینی هەلەکە',
      backToAll: 'هەموو هەلە کارییەکان',
      applyNow: 'ئێستا داواکاری بکە',
      applyForRole: 'داواکاری بۆ ئەم هەلە بکە',
      whatYouWillDo: 'چی دەکەیت',
      whatWereLookingFor: 'بەدوای چی دەگەڕێین',
      ogSuffix: 'هەلی کاری داتاکۆد',
    },
  },
} as const;
